// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"de2bbb1d","583":"f1872ab6","878":"7ca966df"}[chunkId] + ".chunk.js";
};